import { render, staticRenderFns } from "./index.task.vue?vue&type=template&id=c3af8c34&scoped=true&lang=pug"
import script from "./index.task.vue?vue&type=script&lang=js"
export * from "./index.task.vue?vue&type=script&lang=js"
import style0 from "./index.task.vue?vue&type=style&index=0&id=c3af8c34&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3af8c34",
  null
  
)

export default component.exports